import { getCertificates } from "../../../shared/api/ui";
import { useQuery } from "@tanstack/react-query";
import type { CertificatesResponse } from "../../../shared/types/certificates.type";

const fetchCertificates = async (): Promise<CertificatesResponse> => {
	const response = await getCertificates();
	if (!response.success || response.data == null) {
		throw new Error(response.message ?? "Certificates request failed");
	}
	return response.data;
};

export const useCertificates = () => {
	return useQuery({
		queryKey: ["certificates"],
		queryFn: fetchCertificates,
		staleTime: 1000 * 60 * 5,
		refetchInterval: 1000 * 60 * 5,
		refetchOnWindowFocus: true,
		retry: 2,
		retryDelay: (attemptIndex) =>
			Math.min(1000 * 2 ** attemptIndex, 10_000),
	});
};
